import { render, staticRenderFns } from "./HeaderMegaMenu.vue?vue&type=template&id=2b69738b&"
import script from "./HeaderMegaMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderMegaMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HeaderMegaMenu.vue"
export default component.exports